import React from 'react';
import { TAB_SELECTION } from '../CourierListMobile';
import { COURIER_STATUS, TCourier } from '../../services/api';
import PIEText from '@src/shared/components/PIEText';
import { Trans } from 'react-i18next';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import CourierCard, { ICourierSelectedProps } from '../CourierCard';
import useOCFStatus from '@src/shared/hooks/use-ocf-status';

interface componentProps {
  tabSelectionValue?: TAB_SELECTION;
  courierListData: TCourier[];
  onCourierSelected?: (courier: ICourierSelectedProps, isCourierPending: boolean) => void;
  disableFilter?: boolean;
}

const CourierListFiltered = ({
  tabSelectionValue,
  courierListData,
  onCourierSelected = () => {},
  disableFilter = false,
}: componentProps) => {
  const { isResolutionMobile } = useDeviceDetect();
  const { isOCFEnabled } = useOCFStatus();
  const getCouriersByStatus = (dataset: Array<TCourier>, selectedTab: TAB_SELECTION) => {
    return dataset.filter((res: TCourier) => {
      return selectedTab === TAB_SELECTION.ACTIVE
        ? !!(
            (res.status === COURIER_STATUS.CONNECTED && !isOCFEnabled) ||
            (res.status === COURIER_STATUS.CONNECTED && isOCFEnabled && res.isVerified !== false)
          )
        : res.status !== COURIER_STATUS.CONNECTED &&
            //res.status !== COURIER_STATUS.DISCONNECTED &&
            res.status !== COURIER_STATUS.DECLINED &&
            res.status !== COURIER_STATUS.PENDING_RESTAURANT_ACCEPTANCE;
    });
  };

  const errorMessages = {
    [TAB_SELECTION.ACTIVE]: 'manage_couriers.NO_ACTIVE_COURIERS_PLACEHOLDER',
    [TAB_SELECTION.PENDING]: 'manage_couriers.NO_PENDING_COURIERS_PLACEHOLDER',
  };

  const renderFilteredCouriers = () => {
    let computedCourierList = [];
    if (tabSelectionValue && !disableFilter) {
      computedCourierList = getCouriersByStatus(courierListData, tabSelectionValue).sort(
        (a, b) => new Date(b.dateAdded).getTime() - new Date(a.dateAdded).getTime()
      );
    } else {
      computedCourierList = courierListData.sort(
        (a, b) => new Date(b.dateAdded).getTime() - new Date(a.dateAdded).getTime()
      );
    }

    if (!computedCourierList.length) {
      if (isOCFEnabled) {
        return <></>;
      }
      return (
        <PIEText
          align={'center'}
          text={<Trans i18nKey={errorMessages[tabSelectionValue || TAB_SELECTION.ACTIVE]} />}
          size={'var(--xds-font-size-14)'}
        />
      );
    } else {
      return computedCourierList.map((courier, index) => (
        <CourierCard
          courierData={courier}
          filterType={tabSelectionValue === TAB_SELECTION.ACTIVE ? 'active' : 'pending'}
          key={index}
          onCourierSelected={onCourierSelected}
        />
      ));
    }
  };

  return <>{renderFilteredCouriers()}</>;
};

export default CourierListFiltered;
